import React, { Component } from 'react';
import { gantt } from 'dhtmlx-gantt';
import { GETPLANNINGCHARTDATA } from '../../constants/Config';
import { toast } from 'react-toastify';
import 'dhtmlx-gantt/codebase/skins/dhtmlxgantt_material.css';
import 'dhtmlx-gantt/codebase/locale/locale_nl.js';
import { useTranslation, Trans } from 'react-i18next';
const { t } = useTranslation();

class Gantt extends Component {
    constructor(props) {
        super(props);
        this.state = {
            
        };
    }

    parseGanttData() {
        if(this.props.startDate == "" || this.props.endDate == "") {
            const today = new Date();
            var nexMonth = new Date(today.getFullYear(), today.getMonth()+1, today.getDate());
            
            var startDate = today.getFullYear() + '-' + 1 + '-' + today.getDate();
            var endDate = nexMonth.getFullYear() + '-' + nexMonth.getMonth() + '-' + nexMonth.getDate();
            this.props.setPlanningSearchDates(startDate, endDate);
        } else {
            fetch(GETPLANNINGCHARTDATA + this.props.startDate + '/' + this.props.endDate, {method: 'GET'})
            .then((response) => {
                return response.text().then(text => {
                    const data = text && JSON.parse(text);
                    if (!response.ok) {
                        const error = (data && data.message) || response.statusText;
                         toast.error(error, {
                             position: toast.POSITION.TOP_CENTER
                           });
                        return Promise.reject(error);
                    }
    
                    return data;
                });
            })
            .then((res) => {
                if(res.succeeded === false) {
                    for (let index = 0; index < res.messages.length; index++) {
                         toast.error(res.messages[index], {
                             position: toast.POSITION.TOP_CENTER
                           });
                    }
                    return Promise.reject();
                }
    
                var planningData = res.results;
                planningData.forEach((element, index, array) => {
                    element.duration = element.stepElapsedTimeInHours;
                    delete element.id;
                    element.id = element.stepID;
                    if(element.stepID != element.parentID) {
                         element.parent = element.parentID.toString();
                    }
                    element.open = true;
                    element.text = element.stepName;
                    element.color = element.statusBackgroundColorInHex;
                    element.start_date = element.momentStarted;
                });
    
                gantt.templates.timeline_cell_class = function(item,date){
                    if(date.getDay()==0||date.getDay()==6){
                        return "weekend"
                    }
                };
                gantt.config.start_date = this.props.startDate;
                gantt.config.end_date = this.props.endDate;

                gantt.config.xml_date = "%Y-%m-%d %H:%i";
                gantt.config.order_branch = false;
                gantt.config.order_branch_free = false;
                gantt.config.drag_move = false;
                gantt.config.drag_resize = false;
                gantt.config.drag_links = false;
                gantt.config.drag_progress = false;
                gantt.config.details_on_dblclick = false;
                gantt.config.duration_unit = "hour";
                gantt.config.columns = [{name: "project", label: 'Project', width:120, tree:true}, 
                                        {name: "productCode", label: 'Product', width:120},
                                    {name:"stepCode", label: "stepcode", width:80}];
                gantt.config.worktime = true;
                gantt.clearAll();
                gantt.parse({"data": planningData});
            })
            .catch(function(error) {
                 toast.error(error, {
                     position: toast.POSITION.TOP_CENTER
                   });
            });
        }
    }

    componentDidMount() {
        this.parseGanttData();
        gantt.init(this.ganttContainer);
        gantt.render();
        console.log("-------------------------------------------");
        var test = this.refs;
        console.log(test);
        console.log(gantt);
    }

    setZoom(value) {
        switch (value) {
            case "1":
                gantt.config.scale_unit = 'day';
                gantt.config.date_scale = '%d %M';

                gantt.config.scale_height = 60;
                gantt.config.min_column_width = 30;
                gantt.config.subscales = [
                    { unit: 'hour', step: 1, date: '%H' }
                ];
                break;
            case "2":
                gantt.config.min_column_width = 70;
                gantt.config.scale_unit = 'week';
                gantt.config.date_scale = 'week: %W';
                gantt.config.subscales = [
                    { unit: 'day', step: 1, date: '%d %M' }
                ];
                gantt.config.scale_height = 60;
                break;
            case "3":
                gantt.config.min_column_width = 70;
                gantt.config.scale_unit = 'month';
                gantt.config.date_scale = '%F';
                gantt.config.scale_height = 60;
                gantt.config.subscales = [
                    { unit: 'week', step: 1, date: 'week: %W' }
                ];
                break;
            default:
                break;
        }
    }

    shouldComponentUpdate(nextProps) {
        return this.props.zoom !== nextProps.zoom;
    }

    componentDidUpdate() {
        gantt.render();
    }

    componentWillUnmount() {
        if (this.dataProcessor) {
            this.dataProcessor.destructor();
            this.dataProcessor = null;
        }
    }

    render() {
        const { zoom } = this.props;
        this.setZoom(zoom);

        return (
            <div className="gantt-timeline" ref={(input) => { this.ganttContainer = input }}></div>
        );
    }
}

export default Gantt;